















import Vue from 'vue'
import Component from 'vue-class-component'
import WizardStepJobMatchJobGoal from './jobmatch-steps/WizardStepJobMatchJobGoal.vue'
import WizardStepJobMatchJobtitles from './jobmatch-steps/WizardStepJobMatchJobtitles.vue'
import WizardStepJobMatchLocation from './jobmatch-steps/WizardStepJobMatchLocation.vue'
import WizardStepJobMatchPreviousJobtitles from './jobmatch-steps/WizardStepJobMatchPreviousJobtitles.vue'
import { IWizardStep } from '@app/componentlib/common/types/WizardTypes'
import WizardStepJobMatchEmailNotification from './jobmatch-steps/WizardStepJobMatchEmailNotification.vue'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ISettingsItem } from '@app/componentlib/common/types/JobSearchTypes'

@Component<WizardStep>({
  props: {
    wizardTitle: String,
    wizardstep: Object,
    settings: Object
  },
  components: {
    WizardStepJobMatchLocation,
    WizardStepJobMatchJobGoal,
    WizardStepJobMatchJobtitles,
    WizardStepJobMatchPreviousJobtitles,
    WizardStepJobMatchEmailNotification
  }
})

export default class WizardStep extends Vue {
  /**
   * Props variables
   */
  wizardTitle: string | undefined
  wizardstep: IWizardStep | undefined
  settings: ISettingsItem | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get description (): string  {
    let desc = this.wizardstep?.description ?? ''
    let profileLink = AppModule.portalSettings.profileLink  + '#experience';
    desc = desc
      .replace('/{{profileLink}}', profileLink)
      .replace('{{profileLink}}', profileLink)
    return desc
  }

  /**
   * Methods
   */
  setStorage() {
    if (this.wizardstep?.type === undefined) return
    sessionStorage.setItem('stepToJumpTo', this.wizardstep?.type)
  }

  modifyString(text: string) {
    // Use regular expressions to find the href attribute and its value
    const regex = /href="([^"]*)"/
    const match = text.match(regex)

    if (!match) {
      return text // No match found, return the original text
    }

    const existingLink = match[1]

    // Helper function to add or update a query parameter in a URL
    function addQueryParam(url: string, paramName: string, paramValue: string) {
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}${paramName}=${paramValue}`
    }

    if (existingLink.includes('#')) {
      // URL with a fragment identifier
      const [baseURL, fragment] = existingLink.split('#')
      const updatedURL = addQueryParam(baseURL, 'stepToJumpTo', this.wizardstep?.type!)
      text = text.replace(regex, `href="${updatedURL}#${fragment}"`)
    } else {
      // URL without a fragment identifier
      const updatedURL = addQueryParam(existingLink, 'stepToJumpTo', this.wizardstep?.type!)
      text = text.replace(regex, `href="${updatedURL}"`)
    }

    return text
  }


}
